import React from 'react';
import { isRollout0Feature, contactInfo } from '../../config/featureFlags';

const EmergencyBanner: React.FC = () => {
  if (!isRollout0Feature('emergencyBanner')) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-red-600 text-white py-2 text-center text-sm sm:text-base font-medium">
      <div className="container mx-auto px-4 flex items-center justify-center gap-2">
        <span className="animate-pulse">🚨</span>
        <span>24/7 Emergency Roof Repair Available</span>
        <span className="hidden sm:inline">•</span>
        <a
          href={`tel:${contactInfo.phoneRaw}`}
          className="font-bold underline hover:text-red-100 transition-colors"
        >
          Call Now: {contactInfo.phone}
        </a>
      </div>
    </div>
  );
};

export default EmergencyBanner;
